module.exports = __webpack_public_path__ + "img/oguri_kimono_salon_EN.fd1bee2a.jpg";